// extracted by mini-css-extract-plugin
export default {"titleCon":"styles_titleCon__-4umc","subTitle":"styles_subTitle__yLyNU","rtl":"styles_rtl__PG4Fd","title":"styles_title__blByZ","imgContainer":"styles_imgContainer__5tZ3k"};